import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getWallet = () => {
    return api.get(ENDPOINTS.LOYALTY.WALLET);
};

export const getTransactions = (params) => {
    return api.get(ENDPOINTS.LOYALTY.TRANSACTIONS, { params });
};

export const estimatePoints = (price) => {
    return api.get(ENDPOINTS.LOYALTY.ESTIMATE, { params: { price } });
};

export const validateRedemption = (points) => {
    return api.post(ENDPOINTS.LOYALTY.VALIDATE_REDEEM, { points });
};
